/**
 * Created by roman.kupin on 10/3/2017.
 */

import * as BigPictureActions from "../actions/index";

export default function partnersReducer(state = {
    isInitialized: false
}, {type, payload}) {

    switch (type) {
        case BigPictureActions.INITIALIZED: {
            return Object.assign({}, state, {isInitialized: true, partners: payload});
        }
        default: {
            return state;
        }
    }
}